import React, { createContext, useContext, useState, useCallback, useMemo } from "react";

const DICT = {
  fr: {
    "app.title": "Programme de bourse de soutien destiné aux membres du STEP",
    "app.subtitle": "Travailleuses, travailleurs étudiant.e.s et stagiaires postdoctoraux en situation de précarité financière",
    "app.org": "STEP — Université Laval",
    "nav.apply": "Faire une demande",
    "nav.admin": "Espace administration",
    "hero.badge": "Solidarité · Transparence · Courage",
    "hero.title": "Une aide financière pour les membres en situation de précarité",
    "hero.desc": "Le STEP soutient ses membres. Remplissez ce formulaire confidentiel en 5 étapes pour déposer votre demande de bourse d'aide.",
    "hero.cta": "Commencer ma demande",
    "hero.time": "Environ 15 minutes · Vos données restent confidentielles",
    "welcome.h1": "Programme de bourse de soutien aux membres du STEP",
    "welcome.intro": "Bienvenue sur la plateforme officielle de dépôt des candidatures du Syndicat des travailleuses et des travailleurs étudiants et postdoctoraux de l'Université Laval (STEP). Le STEP dispose de 60 bourses d'un montant de 500 $ pour l'année en cours, soit exactement 30 bourses pour la session d'automne et 30 bourses pour la session d'hiver, afin de soutenir ses membres faisant face à des difficultés financières importantes. Veuillez noter que cette bourse n'est pas cumulative.",
    "welcome.importantLabel": "📌 Important",
    "welcome.important": "Pour simplifier vos démarches, la lettre de présentation papier a été supprimée et intégrée directement sous forme de zone de texte à l'étape 4 de ce formulaire. Vos pièces justificatives seront validées en interne, mais l'évaluation finale par le comité externe se fera de manière 100 % anonyme.",
    "welcome.eligTitle": "Conditions d'admissibilité",
    "welcome.eligIntro": "Pour pouvoir cliquer sur « Commencer ma demande », vous devez certifier que vous remplissez les critères suivants :",
    "welcome.elig1": "Être membre actif du STEP au moment du dépôt.",
    "welcome.elig2": "Être inscrit.e à l'Université Laval à la session en cours.",
    "welcome.elig3": "Ne pas avoir reçu cette bourse du STEP durant les deux (2) dernières années, incluant celle en cours.",
    "welcome.elig4": "Être en situation financière précaire (déficit budgétaire pour les besoins de première nécessité).",
    "welcome.docsTitle": "Pièces justificatives à préparer",
    "welcome.docsIntro": "À la dernière étape, vous devrez téléverser obligatoirement :",
    "welcome.doc1": "Une copie de votre facture des frais de scolarité pour la session en cours (PDF).",
    "welcome.doc2": "Une copie de votre dernier contrat de travail obtenu à l'Université Laval (PDF).",
    "welcome.confirm": "Je confirme avoir pris connaissance des conditions d'admissibilité et des pièces requises.",
    "countdown.title": "Ouverture des dépôts dans",
    "countdown.open": "Les dépôts sont maintenant ouverts !",
    "countdown.date": "Les dépôts démarrent le 21 septembre à 00h00 (heure de l'Est).",
    "countdown.notopen": "Ouverture le 21 septembre à 00h00",
    "countdown.days": "jours",
    "countdown.hours": "heures",
    "countdown.minutes": "minutes",
    "countdown.seconds": "secondes",
    "countdown.unscheduled": "Les dépôts ne sont pas encore ouverts.",
    "countdown.closed": "La période de dépôt est terminée. Les candidatures sont en cours d'évaluation.",
    "countdown.closedOn": "Fermée le",
    "countdown.closesOn": "Fermeture des dépôts le",
    "countdown.opensOn": "Ouverture le",
    "countdown.ended": "Période de dépôt terminée",
    "countdown.period": "Période de dépôt",
    "countdown.next.title": "Prochaine période de dépôt",
    "countdown.next.opens": "Ouverture prévue le",
    "countdown.next.in": "dans",
    "admin.next.title": "Prochaine session annoncée",
    "admin.next.hint": "Affichée sur la page d'accueil uniquement lorsque les dépôts sont fermés ou terminés.",
    "admin.next.current": "Annonce actuelle",
    "admin.next.none": "Aucune annonce publiée.",
    "admin.next.date": "Date d'ouverture prévue",
    "admin.next.label": "Libellé (optionnel)",
    "admin.next.labelPlaceholder": "ex. Session d'hiver 2027",
    "admin.next.save": "Publier",
    "admin.next.clear": "Retirer l'annonce",
    "admin.next.saved": "Annonce mise à jour.",
    "admin.deposit.title": "Période de dépôt (début et fin)",
    "admin.deposit.current": "Ouverture programmée",
    "admin.deposit.closes": "Fermeture",
    "admin.deposit.noEnd": "non programmée",
    "admin.deposit.start": "Début des dépôts",
    "admin.deposit.end": "Fin des dépôts",
    "admin.deposit.none": "Aucune date programmée — les dépôts sont fermés.",
    "admin.deposit.save": "Programmer",
    "admin.deposit.openNow": "Ouvrir maintenant (1 mois)",
    "admin.deposit.closeNow": "Fermer maintenant",
    "admin.deposit.reset": "Réinitialiser",
    "admin.deposit.saved": "Période de dépôt mise à jour.",
    "admin.deposit.invalidRange": "La date de fin doit être postérieure à la date de début.",
    "admin.deposit.oneMonthHint": "La date de fin est proposée automatiquement à 1 mois après le début ; vous pouvez la modifier.",
    "admin.deposit.badge.open": "Dépôts ouverts",
    "admin.deposit.badge.upcoming": "Ouverture à venir",
    "admin.deposit.badge.closed": "Dépôts terminés",
    "admin.deposit.badge.unscheduled": "Dépôts fermés",
    "welcome.cta": "Commencer ma demande",
    "step.of": "Étape {n} sur 5",
    "btn.next": "Suivant",
    "btn.prev": "Précédent",
    "draft.save": "Enregistrer et quitter",
    "draft.title": "Enregistrer ma progression",
    "draft.desc": "Entrez votre courriel : nous vous enverrons un lien personnel pour reprendre votre demande plus tard, depuis n'importe quel appareil.",
    "draft.email": "Courriel",
    "draft.send": "Envoyer le lien et quitter",
    "draft.sending": "Envoi…",
    "draft.savedTitle": "Progression enregistrée",
    "draft.savedDesc": "Un lien de reprise a été envoyé à {email}. Vous pouvez fermer cette page et revenir plus tard. N'oubliez pas de soumettre votre demande avant la fin de la période de dépôt.",
    "draft.resend": "Renvoyer le lien",
    "draft.resent": "Lien renvoyé.",
    "draft.continue": "Continuer maintenant",
    "draft.home": "Retour à l'accueil",
    "draft.resumed": "Votre demande a été reprise là où vous l'aviez laissée.",
    "draft.notFound": "Ce lien de reprise n'est plus valide (demande déjà soumise ou introuvable).",
    "draft.autosaved": "Enregistré à {time}",
    "draft.resumeBanner": "Un brouillon enregistré le {date} a été trouvé sur cet appareil.",
    "draft.resumeBtn": "Reprendre",
    "draft.restartBtn": "Recommencer à zéro",
    "draft.invalidEmail": "Adresse courriel invalide.",
    "dup.title": "Demande déjà existante",
    "dup.blocked": "Impossible de poursuivre : une demande existe déjà pour ces informations.",
    "btn.submit": "Soumettre ma demande",
    "btn.submitting": "Envoi en cours…",
    "yes": "Oui",
    "no": "Non",
    "required": "Champ obligatoire",
    "summary.title": "Sommaire budgétaire (mensuel estimé)",
    "summary.expenses": "Total des dépenses",
    "summary.note": "Ce sommaire est indicatif et vous aide à vérifier vos montants.",
    "step5.upload": "Déposer un fichier PDF",
    "step5.uploaded": "Fichier téléversé",
    "step5.replace": "Remplacer",
    "step5.facture": "Facture des frais de scolarité (session en cours)",
    "step5.contrat": "Dernier contrat obtenu à l'Université Laval",
    "step5.pdfonly": "Format PDF uniquement · max 15 Mo",
    "step5.attestation": "J'atteste que l'information fournie dans le présent formulaire de candidature et dans la documentation d'accompagnement est véridique, exacte et complète. Je comprends que toute fausse déclaration pourrait entraîner le rejet de ma demande de bourse.",
    "step5.date": "Date du jour",
    "err.lettre": "La lettre de présentation est obligatoire.",
    "err.files": "Les deux documents PDF sont obligatoires.",
    "err.attestation": "Vous devez cocher l'attestation.",
    "err.required": "Veuillez remplir les champs obligatoires.",
    "conf.title": "Demande reçue avec succès",
    "conf.desc": "Merci ! Votre demande de bourse a bien été enregistrée. Un courriel de confirmation vous a été envoyé.",
    "conf.code": "Votre numéro de référence anonyme",
    "conf.keep": "Conservez ce numéro pour toute correspondance avec le STEP.",
    "conf.new": "Nouvelle demande",
    "conf.date": "Date de soumission",
    "admin.login": "Connexion administration",
    "admin.logindesc": "Réservé à l'équipe interne du STEP. Connectez-vous avec votre compte Google autorisé.",
    "admin.google": "Se connecter avec Google",
    "admin.title": "Tableau de bord des candidatures",
    "admin.total": "candidature(s)",
    "admin.search": "Rechercher (nom, code, programme)…",
    "admin.exportFull": "Export complet (Interne STEP)",
    "admin.exportAnon": "Export anonyme (Comité externe)",
    "admin.exportScoring": "Scoring comité (Excel)",
    "admin.codeComite": "N° comité",
    "admin.heuresTravail": "Heures de travail / sem.",
    "admin.resteScolarite": "Reste à payer scolarité",
    "export.titleFull": "Export complet — choisir les colonnes",
    "export.titleAnon": "Export comité externe — choisir les colonnes",
    "export.descFull": "Sélectionnez les colonnes à inclure. Votre sélection est mémorisée pour les prochains exports.",
    "export.descAnon": "Les données nominatives (cadenas) sont toujours exclues. Le « Numéro comité externe » remplace le code anonyme.",
    "export.presets": "Préréglages",
    "export.all": "Tout",
    "export.none": "Rien",
    "export.essential": "Essentiel",
    "export.committee": "Comité (résumé)",
    "export.selected": "colonnes sélectionnées",
    "export.locked": "Exclu de l'export anonyme",
    "admin.export.excel": "Excel (.xlsx)",
    "admin.export.csv": "CSV (.csv)",
    "admin.logout": "Déconnexion",
    "admin.col.code": "Code",
    "admin.col.name": "Candidat.e",
    "admin.col.program": "Programme / Cycle",
    "admin.col.status": "Statut",
    "admin.col.grant": "Bourse",
    "admin.col.actions": "Actions",
    "admin.view": "Ouvrir le dossier",
    "admin.noresults": "Aucune candidature trouvée.",
    "admin.section": "Section réservée à l'administration",
    "admin.statutDossier": "Statut du dossier",
    "admin.bourse": "Bourse accordée ($)",
    "admin.versement": "Versement effectué",
    "admin.notes": "Notes internes",
    "admin.save": "Enregistrer",
    "admin.saved": "Modifications enregistrées",
    "admin.docs": "Pièces justificatives",
    "admin.letter": "Lettre de présentation",
    "admin.downloadFacture": "Facture de scolarité (PDF)",
    "admin.downloadContrat": "Contrat ULaval (PDF)",
    "admin.filter.all": "Tous les statuts",
    "status.en_attente": "En attente",
    "status.approuve": "Approuvé",
    "status.rejete": "Rejeté",
    "status.incomplet": "Incomplet",
    "nav.track": "Suivre ma demande",
    "track.title": "Suivre ma demande",
    "track.desc": "Entrez votre numéro de référence anonyme (ex. CAND-001) pour connaître l'état de votre dossier.",
    "track.placeholder": "CAND-001",
    "track.btn": "Vérifier",
    "track.notfound": "Aucun dossier trouvé pour ce numéro.",
    "track.statusLabel": "État du dossier",
    "track.submitted": "Date de soumission",
    "track.grant": "Bourse accordée",
    "track.payment": "Versement effectué",
    "admin.deficit": "Déficit",
    "admin.sort.recent": "Plus récentes",
    "admin.sort.deficit_desc": "Déficit (élevé → bas)",
    "admin.sort.deficit_asc": "Déficit (bas → élevé)",
    "admin.preview": "Aperçu",
    "admin.hidePreview": "Masquer l'aperçu",
    "admin.summary": "Aperçu financier",
    "admin.revenus": "Revenus",
    "admin.depenses": "Dépenses",
    "admin.deficitLabel": "Déficit",
    "admin.history": "Historique des décisions",
    "admin.history.empty": "Aucune modification de statut pour le moment.",
    "admin.history.by": "par",
    "admin.tab.active": "Demandes actives",
    "admin.tab.archives": "Archives",
    "admin.tab.stats": "Statistiques",
    "admin.bilan.title": "Bilan en direct",
    "admin.stats.paidTitle": "Montant total versé par session",
    "admin.stats.grantsTitle": "Bourses accordées par session",
    "admin.stats.empty": "Aucune donnée archivée pour générer des statistiques.",
    "admin.stats.yearFilter": "Année",
    "admin.stats.allYears": "Toutes les années",
    "admin.stats.download": "Télécharger (PNG)",
    "admin.stats.trendTitle": "Tendance : montant versé cumulé par année",
    "admin.stats.cumulative": "Cumulé",
    "admin.stats.annual": "Annuel",
    "admin.stats.pdf": "Bilan PDF",
    "admin.archive.title": "Archiver les demandes",
    "admin.archive.desc": "Après la fermeture des dépôts, archivez toutes les demandes actives sous une session et une année. Elles seront retirées de la liste principale et consultables dans l'onglet Archives.",
    "admin.archive.session": "Session",
    "admin.archive.year": "Année",
    "admin.archive.session.automne": "Automne",
    "admin.archive.session.hiver": "Hiver",
    "admin.archive.btn": "Archiver toutes les demandes actives",
    "admin.archive.confirmTitle": "Confirmer l'archivage",
    "admin.archive.confirmDesc": "Toutes les demandes actives seront archivées sous {session} {year}. Cette action peut être annulée en désarchivant chaque demande.",
    "admin.archive.confirmBtn": "Confirmer l'archivage",
    "admin.archive.cancel": "Annuler",
    "admin.archive.count": "demande(s) archivée(s)",
    "admin.archive.select": "Sélectionner une archive",
    "admin.archive.none": "Aucune archive pour le moment.",
    "admin.archive.noneActive": "Aucune demande active à archiver.",
    "admin.archive.archivedBy": "Archivé par",
    "admin.archive.on": "le",
    "admin.archive.unarchive": "Désarchiver",
    "admin.archive.unarchived": "Demande restaurée dans les demandes actives.",
    "admin.archive.groupCount": "demande(s) dans cette archive",
    "admin.archive.grants": "Bourses accordées",
    "admin.archive.totalPaid": "Montant total versé",
    "admin.archive.journal": "Journal d'archivage",
    "admin.archive.journalEmpty": "Aucune activité d'archivage pour le moment.",
    "admin.archive.actionArchive": "Archivage",
    "admin.archive.actionUnarchive": "Désarchivage",
    "admin.deposit.pickPlaceholder": "jj/mm/aaaa hh:mm",
    "admin.grant.title": "Montant standard de la bourse",
    "admin.grant.current": "Montant actuel",
    "admin.grant.hint": "appliqué automatiquement lorsqu'un dossier passe à « Approuvé » (modifiable dossier par dossier).",
    "admin.grant.save": "Enregistrer le montant",
    "admin.grant.saved": "Montant standard mis à jour.",
    "admin.grant.invalid": "Montant invalide.",
    "close": "Fermer",
  },
  en: {
    "app.title": "Support scholarship program for STEP members",
    "app.subtitle": "Student workers and postdoctoral trainees in financial precarity",
    "app.org": "STEP — Université Laval",
    "nav.apply": "Apply",
    "nav.admin": "Admin portal",
    "hero.badge": "Solidarity · Transparency · Courage",
    "hero.title": "Financial support for members in precarious situations",
    "hero.desc": "STEP supports its members. Complete this confidential 5-step form to submit your financial aid scholarship application.",
    "hero.cta": "Start my application",
    "hero.time": "About 15 minutes · Your data stays confidential",
    "welcome.h1": "Support scholarship program for STEP members",
    "welcome.intro": "Welcome to the official application platform of the Union of Student and Postdoctoral Workers of Université Laval (STEP). STEP offers 60 scholarships of $500 for the current year, exactly 30 scholarships for the fall session and 30 for the winter session, to support members facing significant financial hardship. Please note that this scholarship is not cumulative.",
    "welcome.importantLabel": "📌 Important",
    "welcome.important": "To simplify your process, the paper cover letter has been removed and integrated directly as a text area in step 4 of this form. Your supporting documents will be validated internally, but the final evaluation by the external committee will be done 100% anonymously.",
    "welcome.eligTitle": "Eligibility conditions",
    "welcome.eligIntro": "To be able to click \"Start my application\", you must certify that you meet the following criteria:",
    "welcome.elig1": "Be an active STEP member at the time of submission.",
    "welcome.elig2": "Be enrolled at Université Laval for the current session.",
    "welcome.elig3": "Not have received this STEP scholarship during the last two (2) years, including the current one.",
    "welcome.elig4": "Be in a precarious financial situation (budget deficit for basic necessities).",
    "welcome.docsTitle": "Supporting documents to prepare",
    "welcome.docsIntro": "At the last step, you will be required to upload:",
    "welcome.doc1": "A copy of your tuition fee invoice for the current session (PDF).",
    "welcome.doc2": "A copy of your latest employment contract obtained at Université Laval (PDF).",
    "welcome.confirm": "I confirm that I have read the eligibility conditions and required documents.",
    "countdown.title": "Applications open in",
    "countdown.open": "Applications are now open!",
    "countdown.date": "Applications start on September 21 at 00:00 (Eastern Time).",
    "countdown.notopen": "Opens September 21 at 00:00",
    "countdown.days": "days",
    "countdown.hours": "hours",
    "countdown.minutes": "minutes",
    "countdown.seconds": "seconds",
    "countdown.unscheduled": "Applications are not open yet.",
    "countdown.closed": "The application period has ended. Applications are now being evaluated.",
    "countdown.closedOn": "Closed on",
    "countdown.closesOn": "Applications close on",
    "countdown.opensOn": "Opens on",
    "countdown.ended": "Application period ended",
    "countdown.period": "Application period",
    "countdown.next.title": "Next application period",
    "countdown.next.opens": "Planned opening on",
    "countdown.next.in": "in",
    "admin.next.title": "Next session announcement",
    "admin.next.hint": "Shown on the landing page only while applications are closed or ended.",
    "admin.next.current": "Current announcement",
    "admin.next.none": "No announcement published.",
    "admin.next.date": "Planned opening date",
    "admin.next.label": "Label (optional)",
    "admin.next.labelPlaceholder": "e.g. Winter 2027 session",
    "admin.next.save": "Publish",
    "admin.next.clear": "Remove announcement",
    "admin.next.saved": "Announcement updated.",
    "admin.deposit.title": "Application period (start and end)",
    "admin.deposit.current": "Scheduled opening",
    "admin.deposit.closes": "Closing",
    "admin.deposit.noEnd": "not scheduled",
    "admin.deposit.start": "Applications open",
    "admin.deposit.end": "Applications close",
    "admin.deposit.none": "No date scheduled — applications are closed.",
    "admin.deposit.save": "Schedule",
    "admin.deposit.openNow": "Open now (1 month)",
    "admin.deposit.closeNow": "Close now",
    "admin.deposit.reset": "Reset",
    "admin.deposit.saved": "Application period updated.",
    "admin.deposit.invalidRange": "The end date must be after the start date.",
    "admin.deposit.oneMonthHint": "The end date is automatically suggested 1 month after the start; you can change it.",
    "admin.deposit.badge.open": "Applications open",
    "admin.deposit.badge.upcoming": "Opening soon",
    "admin.deposit.badge.closed": "Applications ended",
    "admin.deposit.badge.unscheduled": "Applications closed",
    "welcome.cta": "Start my application",
    "step.of": "Step {n} of 5",
    "btn.next": "Next",
    "btn.prev": "Previous",
    "draft.save": "Save and exit",
    "draft.title": "Save my progress",
    "draft.desc": "Enter your email: we will send you a personal link to resume your application later, from any device.",
    "draft.email": "Email",
    "draft.send": "Send the link and exit",
    "draft.sending": "Sending…",
    "draft.savedTitle": "Progress saved",
    "draft.savedDesc": "A resume link has been sent to {email}. You can close this page and come back later. Remember to submit your application before the end of the application period.",
    "draft.resend": "Resend the link",
    "draft.resent": "Link resent.",
    "draft.continue": "Continue now",
    "draft.home": "Back to home",
    "draft.resumed": "Your application has been resumed where you left off.",
    "draft.notFound": "This resume link is no longer valid (application already submitted or not found).",
    "draft.autosaved": "Saved at {time}",
    "draft.resumeBanner": "A draft saved on {date} was found on this device.",
    "draft.resumeBtn": "Resume",
    "draft.restartBtn": "Start over",
    "draft.invalidEmail": "Invalid email address.",
    "dup.title": "Application already exists",
    "dup.blocked": "Cannot continue: an application already exists for this information.",
    "btn.submit": "Submit my application",
    "btn.submitting": "Submitting…",
    "yes": "Yes",
    "no": "No",
    "required": "Required field",
    "summary.title": "Budget summary (estimated monthly)",
    "summary.expenses": "Total expenses",
    "summary.note": "This summary is indicative and helps you verify your amounts.",
    "step5.upload": "Upload a PDF file",
    "step5.uploaded": "File uploaded",
    "step5.replace": "Replace",
    "step5.facture": "Tuition invoice (current session)",
    "step5.contrat": "Latest contract obtained at Université Laval",
    "step5.pdfonly": "PDF format only · max 15 MB",
    "step5.attestation": "I attest that the information provided in this application form and supporting documentation is truthful, accurate and complete. I understand that any false declaration could result in the rejection of my scholarship application.",
    "step5.date": "Today's date",
    "err.lettre": "The cover letter is required.",
    "err.files": "Both PDF documents are required.",
    "err.attestation": "You must check the attestation.",
    "err.required": "Please complete the required fields.",
    "conf.title": "Application received successfully",
    "conf.desc": "Thank you! Your scholarship application has been recorded. A confirmation email has been sent to you.",
    "conf.code": "Your anonymous reference number",
    "conf.keep": "Keep this number for any correspondence with STEP.",
    "conf.new": "New application",
    "conf.date": "Submission date",
    "admin.login": "Admin login",
    "admin.logindesc": "Reserved for the internal STEP team. Sign in with your authorized Google account.",
    "admin.google": "Sign in with Google",
    "admin.title": "Applications dashboard",
    "admin.total": "application(s)",
    "admin.search": "Search (name, code, program)…",
    "admin.exportFull": "Full export (Internal STEP)",
    "admin.exportAnon": "Anonymous export (External committee)",
    "admin.exportScoring": "Committee scoring (Excel)",
    "admin.codeComite": "Committee #",
    "admin.heuresTravail": "Work hours / week",
    "admin.resteScolarite": "Tuition remaining",
    "export.titleFull": "Full export — choose columns",
    "export.titleAnon": "External committee export — choose columns",
    "export.descFull": "Select the columns to include. Your selection is remembered for future exports.",
    "export.descAnon": "Personal data (padlock) is always excluded. The “External committee number” replaces the anonymous code.",
    "export.presets": "Presets",
    "export.all": "All",
    "export.none": "None",
    "export.essential": "Essential",
    "export.committee": "Committee (summary)",
    "export.selected": "columns selected",
    "export.locked": "Excluded from anonymous export",
    "admin.export.excel": "Excel (.xlsx)",
    "admin.export.csv": "CSV (.csv)",
    "admin.logout": "Sign out",
    "admin.col.code": "Code",
    "admin.col.name": "Applicant",
    "admin.col.program": "Program / Cycle",
    "admin.col.status": "Status",
    "admin.col.grant": "Grant",
    "admin.col.actions": "Actions",
    "admin.view": "Open file",
    "admin.noresults": "No applications found.",
    "admin.section": "Administration-only section",
    "admin.statutDossier": "File status",
    "admin.bourse": "Grant awarded ($)",
    "admin.versement": "Payment made",
    "admin.notes": "Internal notes",
    "admin.save": "Save",
    "admin.saved": "Changes saved",
    "admin.docs": "Supporting documents",
    "admin.letter": "Cover letter",
    "admin.downloadFacture": "Tuition invoice (PDF)",
    "admin.downloadContrat": "ULaval contract (PDF)",
    "admin.filter.all": "All statuses",
    "status.en_attente": "Pending",
    "status.approuve": "Approved",
    "status.rejete": "Rejected",
    "status.incomplet": "Incomplete",
    "nav.track": "Track my application",
    "track.title": "Track my application",
    "track.desc": "Enter your anonymous reference number (e.g. CAND-001) to check your file status.",
    "track.placeholder": "CAND-001",
    "track.btn": "Check",
    "track.notfound": "No file found for this number.",
    "track.statusLabel": "File status",
    "track.submitted": "Submission date",
    "track.grant": "Grant awarded",
    "track.payment": "Payment made",
    "admin.deficit": "Deficit",
    "admin.sort.recent": "Most recent",
    "admin.sort.deficit_desc": "Deficit (high → low)",
    "admin.sort.deficit_asc": "Deficit (low → high)",
    "admin.preview": "Preview",
    "admin.hidePreview": "Hide preview",
    "admin.summary": "Financial overview",
    "admin.revenus": "Income",
    "admin.depenses": "Expenses",
    "admin.deficitLabel": "Deficit",
    "admin.history": "Decision history",
    "admin.history.empty": "No status changes yet.",
    "admin.history.by": "by",
    "admin.tab.active": "Active applications",
    "admin.tab.archives": "Archives",
    "admin.tab.stats": "Statistics",
    "admin.bilan.title": "Live summary",
    "admin.stats.paidTitle": "Total amount paid per session",
    "admin.stats.grantsTitle": "Scholarships awarded per session",
    "admin.stats.empty": "No archived data to generate statistics.",
    "admin.stats.yearFilter": "Year",
    "admin.stats.allYears": "All years",
    "admin.stats.download": "Download (PNG)",
    "admin.stats.trendTitle": "Trend: cumulative amount paid per year",
    "admin.stats.cumulative": "Cumulative",
    "admin.stats.annual": "Annual",
    "admin.stats.pdf": "PDF report",
    "admin.archive.title": "Archive applications",
    "admin.archive.desc": "After applications close, archive all active applications under a session and year. They will be removed from the main list and available in the Archives tab.",
    "admin.archive.session": "Session",
    "admin.archive.year": "Year",
    "admin.archive.session.automne": "Fall",
    "admin.archive.session.hiver": "Winter",
    "admin.archive.btn": "Archive all active applications",
    "admin.archive.confirmTitle": "Confirm archiving",
    "admin.archive.confirmDesc": "All active applications will be archived under {session} {year}. This can be undone by unarchiving each application.",
    "admin.archive.confirmBtn": "Confirm archiving",
    "admin.archive.cancel": "Cancel",
    "admin.archive.count": "application(s) archived",
    "admin.archive.select": "Select an archive",
    "admin.archive.none": "No archives yet.",
    "admin.archive.noneActive": "No active applications to archive.",
    "admin.archive.archivedBy": "Archived by",
    "admin.archive.on": "on",
    "admin.archive.unarchive": "Unarchive",
    "admin.archive.unarchived": "Application restored to active applications.",
    "admin.archive.groupCount": "application(s) in this archive",
    "admin.archive.grants": "Scholarships awarded",
    "admin.archive.totalPaid": "Total amount paid",
    "admin.archive.journal": "Archive journal",
    "admin.archive.journalEmpty": "No archiving activity yet.",
    "admin.archive.actionArchive": "Archived",
    "admin.archive.actionUnarchive": "Unarchived",
    "admin.deposit.pickPlaceholder": "dd/mm/yyyy hh:mm",
    "admin.grant.title": "Standard grant amount",
    "admin.grant.current": "Current amount",
    "admin.grant.hint": "applied automatically when a file is set to “Approved” (editable per file).",
    "admin.grant.save": "Save amount",
    "admin.grant.saved": "Standard amount updated.",
    "admin.grant.invalid": "Invalid amount.",
    "close": "Close",
  },
};

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState("fr");
  const t = useCallback((key, vars) => {
    let s = (DICT[lang] && DICT[lang][key]) || key;
    if (vars) Object.keys(vars).forEach((k) => { s = s.replace(`{${k}}`, vars[k]); });
    return s;
  }, [lang]);
  const value = useMemo(() => ({ lang, setLang, t }), [lang, t]);
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export function useLang() {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be used within LangProvider");
  return ctx;
}
